import React from "react";
import { MessageCircle, Phone, Mail, MapPin } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { WHATSAPP, PHONE } from "../mock";
import { Button } from "./ui/button";
import useReveal from "../hooks/useReveal";

export default function Contact() {
  const { t, S } = useLang();
  const ref = useReveal();
  const waLink = `https://wa.me/${WHATSAPP}?text=${encodeURIComponent(
    "Hola XPERIENCIAS MEXICO, quiero información sobre un traslado."
  )}`;

  return (
    <section id="contacto" ref={ref} className="py-20 md:py-28 section-tint">
      <div className="max-w-4xl mx-auto px-5 md:px-8 text-center">
        <div className="reveal">
          <span className="inline-block text-sm font-bold tracking-[0.18em] uppercase text-primary">
            {t(S.contact.kicker)}
          </span>
          <h2 className="mt-3 font-display font-extrabold text-3xl md:text-4xl text-foreground">
            {t(S.contact.title)}
          </h2>
          <p className="mt-4 text-lg text-muted-foreground">{t(S.contact.sub)}</p>
        </div>

        <div className="mt-9 reveal flex flex-wrap justify-center gap-4">
          <Button
            asChild
            size="lg"
            className="bg-[#25D366] hover:bg-[#20bd5a] text-white font-semibold rounded-full px-7 h-13"
          >
            <a href={waLink} target="_blank" rel="noopener noreferrer">
              <MessageCircle className="w-5 h-5" />
              {t(S.contact.whatsapp)}
            </a>
          </Button>
          <Button
            asChild
            size="lg"
            variant="outline"
            className="rounded-full px-7 h-13 border-primary text-primary hover:bg-primary hover:text-primary-foreground"
          >
            <a href={`tel:${PHONE}`}>
              <Phone className="w-5 h-5" />
              {t(S.contact.call)}
            </a>
          </Button>
        </div>

        <div className="mt-12 reveal grid sm:grid-cols-3 gap-6 text-left">
          {[
            { icon: Phone, label: PHONE, href: `tel:${PHONE}` },
            { icon: Mail, label: "hola@xperienciasmexico.com", href: "mailto:hola@xperienciasmexico.com" },
            { icon: MapPin, label: "Cancún · Riviera Maya, MX", href: null },
          ].map((c) => (
            <div key={c.label} className="flex items-center gap-3 bg-white rounded-xl border border-border p-4">
              <span className="grid place-items-center w-10 h-10 rounded-lg bg-primary/10 text-primary shrink-0">
                <c.icon className="w-5 h-5" />
              </span>
              {c.href ? (
                <a href={c.href} className="text-sm font-medium text-foreground hover:text-primary break-all">{c.label}</a>
              ) : (
                <span className="text-sm font-medium text-foreground">{c.label}</span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
